import { getClientProps } from "../utils";

const { clientName } = getClientProps();
const settings = require(`./${clientName}.js`);

export default settings.default;
